import store from "../store";
import router from "../router";
import { limit, logDetailed } from "./utils";
import { setupRefreshPatientLoop, disableRefreshPatientLoop } from "./patientRefresh";

const events = ["mousemove", "mousedown", "keypress", "DOMMouseScroll", "mousewheel", "touchmove", "MSPointerMove"];

// activity tracking
let inactiveTimeoutID = 0;
// ms before autologout - default 1 minute
let inactiveTimeout = 60000;
// maximum rate of kicking the inactivity timer - default 10 second
const activeLimit = 10000;
export function setupAutologoutEvents() {
    logDetailed("idle", "setupAutologoutEvents");
    if (inactiveTimeoutID) window.clearTimeout(inactiveTimeoutID);

    events.forEach(e => document.addEventListener(e, startInactiveTimer, false));

    store.commit("enableAutoLogout");
    startInactiveTimer();
}
export function disableAutologoutEvents() {
    logDetailed("idle", "disableAutologoutEvents");
    if (inactiveTimeoutID) window.clearTimeout(inactiveTimeoutID);

    events.forEach(e => document.removeEventListener(e, startInactiveTimer));

    store.commit("disableAutoLogout");
}

const startInactiveTimer = limit(() => {
    logDetailed("idle", "startInactiveTimer");
    if (!store.getters.autoLogoutTimer) return;
    if (!store.getters.isAuthenticated) return;
    if (store.getters.isIdle) return;
    if (inactiveTimeoutID) window.clearTimeout(inactiveTimeoutID);
    // Database returns inactivity time limit in minutes, so multiply by 60000 to get time in milliseconds.
    inactiveTimeout = store.getters.autoLogoutTimer * 60000;
    // inactiveTimeout = 60000 // 1min
    inactiveTimeoutID = window.setTimeout(goInactive, inactiveTimeout);
    goActive();
}, activeLimit);

function goInactive() {
    logDetailed("idle", "goInactive - " + Date.now());
    if (!store.getters.disableAutoLogout) {
        store.commit("goInactive");
        disableRefreshPatientLoop();
    }
}
function goActive() {
    logDetailed("idle", "goActive - " + Date.now());
    store.commit("goActive");
}

// Refresh token management
let refreshIntervalID = 0;
let refreshTimeout = 900000; // 15 minutes
//let refreshTimeout = 10000; // 10 seconds
export function setupRefreshTokenLoop() {
    logDetailed("idle", "setupRefreshTokenLoop");
    if (refreshIntervalID) window.clearInterval(refreshIntervalID);
    refreshIntervalID = window.setInterval(refreshAccessToken, refreshTimeout);
}
export function disableRefreshTokenLoop() {
    logDetailed("idle", "disableRefreshTokenLoop");
    if (refreshIntervalID) window.clearInterval(refreshIntervalID);
}

export function refreshAccessToken() {
    logDetailed("idle", "refreshAccessToken");
    if (!store.getters.isAuthenticated)  return logout();
    if (store.getters.refreshTokenExpirationTime < new Date()) return logout();
    return store.dispatch("renewToken").then(() => {
        if (refreshIntervalID) {
            refreshTimeout = 900000;
           // refreshTimeout = 10000;
            window.clearInterval(refreshIntervalID);
            refreshIntervalID = window.setInterval(refreshAccessToken, refreshTimeout);
        }
    }).catch(() =>{
        logout();
    });
}

export function refreshAccessTokenFromBackground() {
    logDetailed("idle", "refreshAccessTokenFromBackground");
    if (!store.getters.isAuthenticated) return logout();
    if ((new Date().getTime() - (store.getters.backgroundTimestamp + (store.getters.autoLogoutTimer * 60000))) > 0) 
    {
      store.commit("displayStatus", { message: "App background time exceeded auto logout time. Automatically logging out", level: "error" });
      return logout();
    }
    return store.dispatch("renewToken").then(() => {
        refreshTimeout = 900000;
        setupRefreshTokenLoop();
        setupAutologoutEvents();
        if (store.getters.userAutoPatientExamRefresh) setupRefreshPatientLoop();

    }).catch(() =>{
        logout();
    });
}

function logout() {
    logDetailed("idle", "logout");
    return store.dispatch("logout").then(() => router.push("/"));
}